import { render, staticRenderFns } from "./CameraChildIntroductionOpdoc.vue?vue&type=template&id=70025a75&scoped=true&"
import script from "./CameraChildIntroductionOpdoc.vue?vue&type=script&lang=ts&"
export * from "./CameraChildIntroductionOpdoc.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildIntroductionOpdoc.vue?vue&type=style&index=0&id=70025a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70025a75",
  null
  
)

export default component.exports